import React from 'react';

const componentClass = 'contentPageNotFound';

const ContentNotFoundPage = ({ isProcessing }) => {
    return <article className={componentClass}>{ !isProcessing ? "You are either lost or have found your way into the construction zone...come back later" : ''}</article> ;
};

export default ContentNotFoundPage;
